import { FC } from "react";
import { ChildrenProps } from "types/childrenProps.type";

export const Section: FC<ChildrenProps> = ({ children }) => (
  <div className="space-y-2 py-7">{children}</div>
);
